<template>
    <DCard
        padding
    >
        <Form
            :newsletter-settings="newsletterSettings"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/NewsletterSettings/Form'

export default {
    name: 'NewsletterSettingsCreate',
    components: {
        Form
    },
    props: {
        newsletterSettings: {
            type: Object,
            default () {
                return {}
            }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.newsletter-settings.store'))
        }
    }
}
</script>
